import { configureStore } from "@reduxjs/toolkit";
import SmeSlice from "../function-components/Redux/SmeSlice";
import BussinessPOCSlice from "../function-components/Redux/BussinessPOCSlice";
import THSlice from "../function-components/Redux/THSlice";

export default configureStore({
 reducer: {
  sme: SmeSlice,
  poc: BussinessPOCSlice,
  traininghost: THSlice,
 },
});
